// In a separate file so we can mock it in tests :(
export function getWindow() {
  return window
}

// These two functions are only used in tests
export const historyChanges = { current: [] }
export const resetHistory = () => {}
